module.exports = __webpack_public_path__ + "static/media/PortfolioItem.c51a774d.png";